import { render } from "./AppNavAccountBtn.vue?vue&type=template&id=bb239fea&scoped=true&ts=true"
import script from "./AppNavAccountBtn.vue?vue&type=script&lang=ts"
export * from "./AppNavAccountBtn.vue?vue&type=script&lang=ts"

import "./AppNavAccountBtn.vue?vue&type=style&index=0&id=bb239fea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb239fea"]])

export default __exports__